inputs-complex-checkbox-check-reports
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      input.form-control(type="hidden" name="{opts.reports_numbers.name}" value="{opts.reports_numbers.value}")
      .row
        .col-md-6(each="{item, namespace in opts.items}" class="{(item.value == '1') ? 'checked' : ''}")
          .d-flex
            span(if="{item.name}")
              .checkbox-fade.fade-in-primary
                input(type="hidden" value="0" name="{ item.name }")
                label
                  input(if="{ item.value == '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChangeCheckbox }" data-id="{namespace}" checked="checked")
                  input(if="{ item.value != '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChangeCheckbox }" data-id="{namespace}")
                  span.cr
                    i.cr-icon.icofont.icofont-ui-check.txt-primary
                  span { item.label }
            span.number-group(if="{ item.number }")
              input.form-group.thin(type="number" value="{item.number.value}" onChange="{ this.onChangeNumber }" data-id="{namespace}")
              span &nbsp;台
        div.help-block(if="{ opts.errors }")
          ul(role="alert")
            li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.complex.checkbox-check-reports');
  style(scoped).
    input.form-control.thin, input.form-control.thin:focus, input.form-control.thin:hover{
      padding: 2px 12px;
      height: calc(1.4em + 0.25rem + 3px);
    }
    .number-group {
      display: none;
    }
    .checked .number-group {
      display: block;
    }
    .number-group input {
      margin-bottom: .2rem;
      display: inline-block;
      width: 4rem;
    }